import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AUTH_PROVIDER, AuthProvider } from '../auth/providers/auth-provider';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private provider: AuthProvider = inject(AUTH_PROVIDER);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.API_BASE_URL)) {
      return next.handle(request);
    }

    return from(this.provider.getAccessToken()).pipe(
      switchMap((token) =>
        next.handle(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })),
      ),
    );
  }
}
